import VueScrollTo from 'vue-scrollto'

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return { x: 0, y: 0 }
  } else {
    if (to.hash) {
      VueScrollTo.scrollTo(to.hash, { offset: -175, easing: 'ease-in-out' })
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
}

export default scrollBehavior



// WEBPACK FOOTER //
// ./src/shared/functionality/scroll-behavior.js